import CustomTable from "./SubComponents/Table";
import PieChart from "../Graphs/CompanyDocs/PieChart";
import { getKeys } from "../../utils/CompanyDocs";

const Promoters = ({
  data,
  tableHeaderData,
  tableData,
  mode,
  onSort,
  sortFilterVal,
  filterVal,
}) => {
  const pieChartLastQuarter =
    data?.length > 0 ? getKeys([...data], "PieChart")[0] : "";

  return (
    <div className="sh-panel-content">
      <div className="sh-table-section">
        <CustomTable
          onSort={onSort}
          mode={mode}
          tableData={tableData}
          tableHeaderData={tableHeaderData}
          sortFilterVal={sortFilterVal}
          filterVal={filterVal}
        />
      </div>

      <div className="sh-chart-section">
        <div className="sh-chart-card">
          <div className="sh-chart-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a2f4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21.21 15.89A10 10 0 1 1 8 2.83" /><path d="M22 12A10 10 0 0 0 12 2v10z" />
            </svg>
            <span>{`Shareholding for ${pieChartLastQuarter}`}</span>
          </div>
          <div className="sh-chart-body">
            <PieChart data={data} pieChartLastQuarter={pieChartLastQuarter} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promoters;
